import { render, staticRenderFns } from "./Instructor.vue?vue&type=template&id=ade96734&"
import script from "./Instructor.vue?vue&type=script&lang=js&"
export * from "./Instructor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/miryamfv/Proyectos/valet/dz0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ade96734')) {
      api.createRecord('ade96734', component.options)
    } else {
      api.reload('ade96734', component.options)
    }
    module.hot.accept("./Instructor.vue?vue&type=template&id=ade96734&", function () {
      api.rerender('ade96734', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/Instructor.vue"
export default component.exports